// extracted by mini-css-extract-plugin
export var accordionItem = "accordion-module--accordion-item--66133";
export var chevronIcon = "accordion-module--chevron-icon--c9423";
export var chevronWrapper = "accordion-module--chevron-wrapper--12b0c";
export var content = "accordion-module--content--a7322";
export var isExpanded = "accordion-module--is-expanded--c9ba4";
export var root = "accordion-module--root--8e562";
export var titleBox = "accordion-module--title-box--a869c";